//export const GEMINI_MODEL_NAME = "gemini-1.5-pro-latest";
export const GEMINI_MODEL_NAME = "2.5-flash-preview-05-20";
export const OPENAI_MODEL_NAME = "gpt-4o";
export const OPENAI_GPT5_MODEL_NAME = "gpt-5";
export const CLAUDE_MODEL_NAME = "3-opus-20240229";
export const GROQ_MODEL_NAME = "llama3-8b-8192";
export const DEEPSEEK_MODEL_NAME = "chat";
export const GROK_MODEL_NAME = "4"
export const KIMI_MODEL_NAME = "k2-0711-preview"
export const GLM_MODEL_NAME = "4.5"

export const GEMINI = "gemini";
export const OPENAI = "openai";
export const CLAUDE = "claude";
export const GROQ = "groq";
export const DEEPSEEK = "deepseek";
export const GROK = "grok"
export const KIMI = "kimi"
export const GLM = "glm"

export const LLM_PROVIDERS = [OPENAI] //GEMINI, OPENAI, CLAUDE, DEEPSEEK, GROK, KIMI, GLM];

export const LLM_COMBINATIONS = [
  // [GEMINI, GEMINI_MODEL_NAME],
  //[OPENAI, OPENAI_MODEL_NAME],
  [OPENAI, OPENAI_GPT5_MODEL_NAME]
  // [CLAUDE, CLAUDE_MODEL_NAME],
  // [DEEPSEEK, DEEPSEEK_MODEL_NAME],
  // [GROK, GROK_MODEL_NAME],
  // [KIMI, KIMI_MODEL_NAME],
  // [GLM, GLM_MODEL_NAME]
];

export const ROWS_PER_PAGE = 12;
